import React, { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Button, Form, Modal } from 'semantic-ui-react';
import { Input } from '../../../lib/custom-ui';

import { useForm } from '../../../hooks';

import styles from './ChannelEditStep.module.scss';

const ChannelEditStep = React.memo(({ defaultValue, onUpdate, onClose }) => {
  const [t] = useTranslation();
  const [data, handleFieldChange] = useForm(() => ({
    name: '',
    ip: '',
    port: 0,
    ...defaultValue,
  }));
  const nameField = useRef(null);

  const [nameError, setNameError] = useState(false);
  const [ipError, setIpError] = useState(false);
  const [portError, setPortError] = useState(false);

  const handleSubmit = useCallback(() => {
    const cleanData = {
      ...data,
      name: data.name.trim(),
      ip: data.ip.trim(),
      port: data.port,
    };

    let error;
    if (!cleanData.name) {
      setNameError(true);
      error = true;
    }
    if (cleanData.ip === '') {
      setIpError(true);
      error = true;
    }
    if (cleanData.port === '') {
      setPortError(true);
      error = true;
    }
    if (error) return;

    if (cleanData !== defaultValue) {
      onUpdate(cleanData);
    }

    onClose();
  }, [defaultValue, onUpdate, onClose, data]);

  useEffect(() => {
    nameField.current.select();
  }, []);

  return (
    <>
      <Modal.Header>
        {t('common.editChannel', {
          context: 'title',
        })}
      </Modal.Header>
      <Modal.Content>
        <Form onSubmit={handleSubmit}>
          <Form.Field required error={nameError} onFocus={() => setNameError(false)}>
            <label htmlFor="name">{t('common.enterChannelTitle')}</label>
            <Input
              fluid
              ref={nameField}
              name="name"
              value={data.name}
              className={styles.field}
              onChange={handleFieldChange}
            />
          </Form.Field>
          <Form.Field required error={ipError} onFocus={() => setIpError(false)}>
            <label htmlFor="ip">{t('common.enterChannelIP')}</label>
            <Input
              fluid
              name="ip"
              value={data.ip}
              className={styles.field}
              onChange={handleFieldChange}
            />
          </Form.Field>
          <Form.Field required error={portError} onFocus={() => setPortError(false)}>
            <label htmlFor="port">{t('common.enterChannelPort')}</label>
            <Input
              fluid
              type="number"
              name="port"
              value={data.port}
              className={styles.field}
              onChange={handleFieldChange}
            />
          </Form.Field>
          <Button color="green" icon="checkmark" content={t('action.save')} floated="right" />
          <div className="clearBoth" />
        </Form>
      </Modal.Content>
    </>
  );
});

ChannelEditStep.propTypes = {
  defaultValue: PropTypes.objectOf(PropTypes.any).isRequired,
  onUpdate: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ChannelEditStep;
